module.exports = __webpack_public_path__ + "static/media/portraitSample.1d770da7.mp4";